import { RootState } from 'editor/src/store/index';

const getThe3dPreviewAvailable = (state: RootState) =>
  state.editorModules.preview.the3dPreviewAvailable && !state.hostSettings.hidePreviewButton;

export default getThe3dPreviewAvailable;
